import { Navigate } from "react-router-dom";

export type AuthenticateRouteType = {
  isAuthenticated: boolean;
  children: React.ReactNode;
  redirectTo: string;
};

function AuthenticateRoute({
  isAuthenticated,
  redirectTo,
  children,
}: AuthenticateRouteType) {
  if (isAuthenticated) {
    // Redirect to the login page if the user is not authenticated
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}

export default AuthenticateRoute;
